import { useMemo } from 'react'
import { UsersModule } from '@/core/modules/users/users.module'
import { assetNameColumn } from '@ui/drawer/common/AffectedAssetsTable'
import {
    TSelectableAsset,
    getSelectableAssets,
} from '@ui/drawer/common/useIssueResolution'
import { useIssueDrawer } from '@ui/drawer/common/useIssueDrawer'

const dedupeByHostname = (assets: TSelectableAsset[]): TSelectableAsset[] => {
    const seenHostnames = new Set<string>()
    return assets.filter(({ hostname }) => {
        if (seenHostnames.has(hostname)) {
            return false
        }
        seenHostnames.add(hostname)
        return true
    })
}

export const useBecIssueDetails = () => {
    const { issue, rows, selectedIds, setSelectedIds, resolution } =
        useIssueDrawer<TBECIssue, TSelectableAsset>({
            store: UsersModule,
            buildRows: (becIssue) =>
                dedupeByHostname(getSelectableAssets(becIssue)),
        })

    const openRules = (issue.rule_data ?? []).filter(
        ({ status }) => status === 'open'
    )

    const columns = useMemo(() => [assetNameColumn()], [])

    const selectedHostnames = new Set(
        rows
            .filter(({ id }) => selectedIds.includes(id))
            .map(({ hostname }) => hostname)
    )
    const selectedPayloads = getSelectableAssets(issue)
        .filter(({ hostname }) => selectedHostnames.has(hostname))
        .map(({ payload }) => payload)

    const selectionDisabled = issue.status !== 'open' || resolution.loading

    return {
        issue,
        rows,
        selectedIds,
        setSelectedIds,
        resolution,
        openRules,
        columns,
        selectedPayloads,
        selectionDisabled,
    }
}
